export let environment = {
  version: '1.12-p',
  // WEBSITE
  production: true,
  
  // ADMIN
  // production: false,

  apiUrl: 'https://api-server.die.app',            // old: 8084
  poesslApiUrl: 'https://api-camper-main.die.app', // old: 8080
  apiKey: 'abcd1234',
  localhost: false,
  
  // JUST FOR IMAGE UPLOAD
  apiUrlLive: 'https://api-content.die.app', // old: 8082
  apiUrlTest: 'https://api-cron.die.app',    // old: 8083
  
  configId: '', 
  configCompany: '',

  payment: {
	  paypalSandbox: {
		  clientId: 'bla', //'AS7G7lGlNi5NezvgdimjVDWUaFgttJCg2UIF58XRXIHWm36UOGvC3VCPkP_4fDupNr9JC5VEMhzsHY9C' //sandbox paypal@dierestaurant.app
	  },
	  paypal: {
      live: true,
		  clientId: 'bla', // 'Af4LBaBY6JLKd8ZsQdlq-iWbBdHJafcO0NvGAFr3mFYHFsXjr9v1_Mqucsmw3wHepeUqlJbptOwzomnH' //live paypal@dierestaurant.app
	  },
    stripe: {
      live: window.location.href.includes('zeitlager')
        ? 'pk_live_51KGlotERb9Hjoq0CskyztQ1ejo7RNXWnQNRtoIwz0wFKhywgvRG6jrCxdmNVRLwWshU28fx3kCsy9tLlYSqDaz5n000uAwPqgi' // ZL live
        : 'pk_live_51GxzxlDwyWa2NkOky1w9i8QVZ5w280vjb6a3ZFtgKtkyPbWwyq1C1XuLpZDYJGQ48rTPho2rLnf27w7tTNFTdHGi00ODeLefsP', // die app live

      test: window.location.href.includes('zeitlager')
      ? 'pk_test_51KGlotERb9Hjoq0Cah3H6h4T3LyCwLnj5NUyiE7VQTfQjUKWh9wqFhmoAtX5cYq0v63lvp581EQGz6MDVBoZv0hK00X8EW90s0' // ZL test
      : 'pk_test_51GxzxlDwyWa2NkOkYuxJZtci2yIMHK1zlG1ym6aYhLSTYuyt8jzhRw64tXd48SGTDQHYFqe3qxUIQ7OleBBA3eRf00IfyeHJF0' // die app test
    }
  },
};
